export { default as ContentfulRenderer } from './contentfulRenderer'
export * from './assetLink'
export * from './contentRow'
export * from './landing'
export * from './productQuartet'
export * from './responsive'
export * from './touts'
export * from './slider'



// WEBPACK FOOTER //
// ./src/modules/contentful/index.js